import React, { useState } from "react";

import dayjs from "dayjs";
import TextArea from "antd/es/input/TextArea";

import {
  Checkbox,
  Radio,
  Select,
  DatePicker,
  Space,
  TimePicker,
  Input,
  notification,
} from "antd";
import axios from "axios";

const { Option } = Select;

const format = "HH:mm";

export default function Employee() {
  const [type, setType] = useState("");
  const [formData, setFormData] = useState(null);
  const [api, contextHolder] = notification.useNotification();
  const [loader, setLoader] = useState(false);

  const handleSubmit = async () => {
    setLoader(true);
    const { data } = await axios.post(
      "/api/employee-connect/admin/reminder",
      formData
    );
    setLoader(false);
    if (data.success) {
      console.log("success");
      setType("");
      setFormData(null);
      api.success({
        message: data.message,
        placement: "top",
      });
    } else {
      api.error({
        message: data.message,
        placement: "top",
      });
    }
  };
  function InputValueChange(field, value) {
    console.log(field, value);
    setFormData((old) => ({
      ...old,
      [field]: value,
    }));
  }

  const handleSelectChange = (value) => {
    onChange(value); // Pass the selected value to the parent component
  };

  const onChangeCheck = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };
  const onChange = (date, dateString) => {
    console.log(date, dateString, "checing data");
  };
  const onChange1 = ({ target: { value } }) => {
    console.log("radio1 checked", value);
    setType(value);
  };
  return (
    <>
      {contextHolder}
      <div className="notification" style={{ overflow: "hidden" }}>
        <div
          className=" box-shadow flex  custom-input responsive-row p-0 default-background-color"
          style={{
            borderRadius: "10px",
          }}
        >
          <h4
            style={{ alignSelf: "center" }}
            className="self-center pl-3 m-0 pr-0 "
          >
            Subject:
          </h4>{" "}
          <Input
            value={formData?.subject}
            className="border-none"
            onChange={(e) => InputValueChange("subject", e.target.value)}
          />
        </div>
        <div
          className=" box-shadow mt-3  custom-input responsive-row p-0 default-background-color"
          style={{
            borderRadius: "10px",
          }}
        >
          <TextArea
            onChange={(e) => InputValueChange("body", e.target.value)}
            rows={10}
            col={10}
            className="border-none"
            value={formData?.body}
          ></TextArea>
        </div>
        <div className="custom-time-picker-style mt-5 ml-3">
          <Radio.Group
            onChange={({ target: { value } }) => {
              InputValueChange("type", value);
              setType(value);
            }}
            value={formData?.type}
            name="radiogroup"
          >
            <Radio value="daily">
              <b>Daily</b>
            </Radio>
            <Radio value="weekly">
              <b>Weekly</b>
            </Radio>
            {/* <Radio value={3}>C</Radio>
                <Radio value={4}>D</Radio> */}
          </Radio.Group>
        </div>
        <ul>
          <li>
            <div className="custom-time-picker-style mt-4">
              <div className="mr-3 w-6-rem">
                <b>Time:</b>
              </div>
              <TimePicker
                minuteStep={5}
                placeholder=""
                className=""
                onChange={(e) => {
                  const formattedDate = dayjs(e.$d)
                    .locale(e.$L) // Set the locale
                    .format("HH:mm");

                  InputValueChange("time", formattedDate);
                }}
                defaultValue={""}
                value={formData?.time ? dayjs(formData?.time, "HH:mm") : null}
                format={format}
              />
            </div>
          </li>
          {type === "weekly" && (
            <li>
              <div className="custom-time-picker-style mt-4">
                <div className="mr-3 w-6-rem">
                  <b>Weekly:</b>
                </div>
                <div
                  className="  custom-input responsive-row p-0 default-background-color"
                  style={{
                    borderRadius: "10px",
                  }}
                >
                  <Select
                    allowClear
                    placeholder=""
                    onChange={(value) => InputValueChange("day", value)}
                    value={formData?.day}
                  >
                    <Option value={1}>Monday</Option>
                    <Option value={2}>Tuesday</Option>
                    <Option value={3}>Wednesday</Option>
                    <Option value={4}>Thursday</Option>
                    <Option value={5}>Friday</Option>
                    <Option value={6}>Saturday</Option>
                    <Option value={7}>Sunday</Option>
                  </Select>
                </div>
              </div>
            </li>
          )}
          <li>
            <div className="flex">
              <div className="custom-time-picker-style mt-4">
                <div className="mr-3 w-6-rem">
                  <b>From:</b>
                </div>
                <DatePicker
                  placeholder=""
                  onChange={(date, dateString) =>
                    InputValueChange("start_date", dateString)
                  }
                  value={
                    formData?.start_date ? dayjs(formData?.start_date) : false
                  }
                />
              </div>
              <div className="custom-time-picker-style mt-4 ml-4">
                <div className="mr-3 ">
                  <b>To:</b>
                </div>
                <DatePicker
                  placeholder=""
                  onChange={(date, dateString) =>
                    InputValueChange("end_date", dateString)
                  }
                  value={formData?.end_date ? dayjs(formData?.end_date) : false}
                />
              </div>
            </div>
          </li>
        </ul>
        <div
          className=" box-shadow   justify-between p-3 pl-2 pr-3 inline-block default-background-color mt-3"
          style={{
            borderRadius: "10px",
          }}
        >
          <div className="flex ">
            <b className="font-17">Companies: </b>
            <div className="ml-4 custom-checkbox-ant font-17">
              <Checkbox.Group
                value={formData?.companies}
                options={[
                  {
                    label: "Corp",
                    value: "DJT Corporation and Investment Pvt Ltd",
                  },
                  {
                    label: "Retail",
                    value: "DJT Retailers Pvt Ltd",
                  },
                  {
                    label: "Fintech",
                    value: "DJT Financial Services Pvt Ltd",
                  },
                  {
                    label: "Fashion",
                    value: "DJT Fashion Pvt Ltd",
                  },
                  {
                    label: "Microfinance",
                    value: "Djt Microfinance Private Limited",
                  },
                ]}
                onChange={(checkedValues) =>
                  InputValueChange("companies", checkedValues)
                }
              />
            </div>
          </div>
        </div>
        <br />
        <br />
        <div className="">
          <button
            onClick={handleSubmit}
            disabled={loader}
            className="primary-btn float-right opacity-100"
            loading={loader}
            iconPosition="end"
          >
            submit
          </button>
        </div>
        <br /> <br />
        <br /> <br />
      </div>
    </>
  );
}
